import { CLEAN_CERTIFICATION_TEST_RESULT, MERGE_CERTIFICATION_TEST_RESULT } from "../consts/actions";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case MERGE_CERTIFICATION_TEST_RESULT: {
      return {
        ...state,
        ...action.payload.certificationTestResult,
      };
    }
    case CLEAN_CERTIFICATION_TEST_RESULT: {
      return {};
    }
    default:
      return state;
  }
};
